import { memo } from "react"

const IconArrowRight = () => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 16.5V16.5C4.3575 16.5 1 13.1425 1 9V9C1 4.8575 4.3575 1.5 8.5 1.5V1.5C12.6425 1.5 16 4.8575 16 9V9C16 13.1425 12.6425 16.5 8.5 16.5Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8327 9.00016H5.16602"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33398 6.5L11.834 9L9.33398 11.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default memo(IconArrowRight)
